import React from 'react';
import { cn } from '../../lib/utils';

const WORKFLOW_EDITOR_CARD_BASE = 'flex min-h-0 flex-col overflow-hidden rounded-xl border shadow-sm';

/**
 * Shared GHL-style workflow editor panel shell.
 * - Docked: in-flow card filling the builder editor slot (flex sibling).
 * - Overlay: absolute card inside the builder body, below the top toolbar.
 */
const WorkflowEditorPanelShell = ({
  isOpen = true,
  children,
  width = 480,
  overlayMode = false,
  chromeHeight: _chromeHeight,
  onOverlayDismiss: _onOverlayDismiss,
  activePanelType,
  className,
  testId,
}) => {
  if (!isOpen) return null;

  const panelWidth = Math.max(0, Number(width) || 480);

  if (overlayMode) {
    return (
      <div
        className={cn(
          WORKFLOW_EDITOR_CARD_BASE,
          'absolute top-0 right-0 z-50 h-full shadow-2xl transition-[width] duration-200 ease-out',
          className,
        )}
        style={{ width: panelWidth }}
        data-workflow-right-panel
        data-workflow-editor-ignore-pan
        data-active-workflow-panel={activePanelType || undefined}
        data-editor-overlay-mode="true"
        data-editor-panel-width={panelWidth}
        data-testid={testId}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={cn(
        WORKFLOW_EDITOR_CARD_BASE,
        'h-full w-full shadow-sm transition-[width] duration-200 ease-out',
        className,
      )}
      data-workflow-right-panel
      data-workflow-editor-ignore-pan
      data-active-workflow-panel={activePanelType || undefined}
      data-editor-overlay-mode="false"
      data-editor-panel-width={panelWidth}
      data-testid={testId}
    >
      {children}
    </div>
  );
};

export default WorkflowEditorPanelShell;
